import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 550px;
  width: 100%;

  .BaseTable {
    .BaseTable__body {
      font-size: 20px;

      .BaseTable__row {
        .BaseTable__row-cell {
          .BaseTable__row-cell-text {
            white-space: unset;
          }

          .BaseTable__expand-icon {
            margin-left: 0 !important;
          }
        }
      }
    }
  }
`;
